import { render, staticRenderFns } from "./PasswordResetLogs.vue?vue&type=template&id=4f45ad54&scoped=true"
import script from "./PasswordResetLogs.vue?vue&type=script&lang=js"
export * from "./PasswordResetLogs.vue?vue&type=script&lang=js"
import style0 from "./PasswordResetLogs.vue?vue&type=style&index=0&id=4f45ad54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f45ad54",
  null
  
)

export default component.exports